import { getGetNodoIconaImageQueryKey, NodoDto } from "@/api";
import CentraleIcon from "@/assets/centrale-icon2.png";
import AziendaIcon from "@/assets/company.png";
import { Box, IconButton } from "@mui/material";
import { Handle, Position } from "@xyflow/react";
import PortaleChip from "../PortaleChip";
import LaunchIcon from "@mui/icons-material/Launch";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function GrafoNodo({
  data: { nodo },
}: {
  data: { nodo: NodoDto };
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const icona = nodo.contenitoreIcona;
  const iconaTitolo =
    icona?.nome ??
    (nodo.tipo === "Azienda" ? t("grafo.azienda") : t("grafo.centrale"));
  const iconaSrc =
    nodo.tipo === "Azienda"
      ? AziendaIcon
      : icona?.id
      ? getGetNodoIconaImageQueryKey(icona.id)[0]
      : CentraleIcon;

  const hasParent = nodo.tipo === "Contenitore";
  const mayHaveChildren = nodo.tipo === "Azienda" || nodo.tipo === "Contenitore";

  return (
    <>
      {hasParent && <Handle type="target" position={Position.Top} />}

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={0.5}
        sx={{ width: "100%", height: "100%", position: "relative" }}
      >
        <IconButton
          sx={{ position: "absolute", top: 0, right: 0, color: "gray" }}
          title={t("azioni.apri")}
          size="small"
          color="primary"
          onClick={() => {
            navigate(`/nodi/${nodo.id}`);
          }}
        >
          <LaunchIcon />
        </IconButton>

        <img
          src={iconaSrc}
          width={24}
          style={{ paddingTop: 4 }}
          alt={iconaTitolo}
        />

        <Box
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: 2, // Change to desired number of lines
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
          }}
        >
          {nodo.nome}
        </Box>

        {nodo.referenteCommerciale && (
          <Box
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2, // Change to desired number of lines
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              fontSize: 8,
            }}
          >
            ({nodo.referenteCommerciale.name}
            {nodo.referenteCommerciale.lastName})
          </Box>
        )}

        {/* <Box
          display="flex"
          flexDirection="row"
          columnGap={1}
          sx={{ zoom: 0.5,  width: '100%'}}
          justifyContent="flex-start"
        >
          {nodo.portali.map((p) => (
            <PortaleChip key={p.portaleId} portale={p.portaleId} />
          ))}
        </Box> */}
      </Box>

      {mayHaveChildren && <Handle type="source" position={Position.Bottom} />}
    </>
  );
}
